import React, { Component } from "react";
import { connect } from "react-redux";
import { Icon, Button } from "antd";
import Table from "../table/Table";
import {
  fetchOnHoldOrders,
  onHoldStatusChange,
  getOrderDetailsForPage,
} from "../../homeActions";
import Paginater from "../table/Paginater";
import { openModal } from "../../../modal/modalActions";
import { PermissibleRender } from "@brainhubeu/react-permissible";
import { getUserPermissions } from "../../../../app/common/util/genericUtils";
import MobileOrderActions from "../MobileOrderActions";
import {
  ORDER_LIST_PAGE_SIZE,
  getOrderRowClassName,
  renderOrderNumberCell,
  renderReferenceIdCell,
  renderDateTimeCell,
  renderSourceCell,
  renderCustomerCell,
  renderCoatingCell,
  renderLnamCell,
  renderLabelsCell,
} from "../table/orderTableCells";

class OnHoldTab extends Component {
  columns = [
    {
      title: "Order No.",
      dataIndex: "internal_order_id",
      sorter: (a, b) => a.internal_order_id - b.internal_order_id,
      sortDirections: ["ascend"],
      render: (text, record, index) =>
        renderOrderNumberCell(text, record, () =>
          this.props.getOrderDetailsForPage(record.id, index)
        ),
    },
    {
      title: "Reference Id",
      dataIndex: "reference_id",
      render: renderReferenceIdCell,
    },
    {
      title: "Entry Date & Time",
      dataIndex: "received_date",
      render: renderDateTimeCell,
    },
    {
      title: "Coating",
      dataIndex: "coating.value",
      mobileHidden: true,
      render: renderCoatingCell,
    },
    {
      title: "LNAM",
      dataIndex: "lnam.name",
      mobileHidden: true,
      render: renderLnamCell,
    },
    {
      title: "Customer",
      dataIndex: "customer.name",
      mobileHidden: true,
      render: renderCustomerCell,
    },
    {
      title: "Order Source",
      dataIndex: "source",
      mobileHidden: true,
      render: renderSourceCell,
    },
    {
      title: "Labels",
      width: 150,
      mobileHidden: true,
      render: renderLabelsCell,
    },
    {
      title: "Hold Reason",
      dataIndex: "reason",
      mobileHidden: true,
      render: (text) =>
        text ? (
          <span className="order-hold-reason">{text}</span>
        ) : (
          <span className="order-cell-muted">—</span>
        ),
    },
    {
      title: "Actions",
      fixed: "right",
      width: 150,
      className: "order-actions-column",
      render: (text, record) => {
        const data = {
          record,
          actions: ["fetchOnHoldOrders"],
        };
        const userPermissions = getUserPermissions();
        return (
          <MobileOrderActions>
            <div className="order-actions-icons">
              <Icon
                type="check"
                className="tick-icon"
                onClick={() => this.props.onHoldStatusChange(record.id)}
              />
              <Icon
                type="close"
                className="cross-icon"
                onClick={() => this.props.openModal("CancellationModal", data)}
              />
            </div>
            <PermissibleRender
              userPermissions={userPermissions}
              requiredPermissions={["can_add_label"]}
            >
              <Button
                className="order-action-btn"
                size="small"
                type="primary"
                onClick={() =>
                  this.props.openModal("CreateLabelModal", { id: record.id })
                }
              >
                Add Label
              </Button>
            </PermissibleRender>
            <PermissibleRender
              userPermissions={userPermissions}
              requiredPermissions={["can_link_order"]}
            >
              <Button
                className="order-action-btn"
                size="small"
                type="primary"
                onClick={() =>
                  this.props.openModal("LinkedOrderModal", {
                    type: "linkOldOrder",
                    linkingOrderId: record.id,
                  })
                }
              >
                Link Order
              </Button>
            </PermissibleRender>
          </MobileOrderActions>
        );
      },
    },
  ];

  render() {
    const { loading, orders, fetchOnHoldOrders } = this.props;
    const results = (orders && orders.results) || [];
    const total = (orders && orders.count) || 0;

    return (
      <div className="home-order-tab-pane">
        <Table
          columns={this.columns}
          loading={loading}
          data={results}
          rowClassName={getOrderRowClassName}
          pagination={false}
          bordered={false}
          size="middle"
        />
        <Paginater
          defaultCurrent={1}
          total={total}
          onChange={fetchOnHoldOrders}
          pageSize={ORDER_LIST_PAGE_SIZE}
        />
      </div>
    );
  }
}

const actions = {
  fetchOnHoldOrders,
  onHoldStatusChange,
  getOrderDetailsForPage,
  openModal,
};

const mapStateToProps = (state) => ({
  loading: state.home.loadingOnHoldOrders,
  orders: state.home.onHoldOrders,
  activeTabKey: state.home.activeTabKey,
});

export default connect(
  mapStateToProps,
  actions
)(OnHoldTab);
